/* eslint-disable */

/** unique or primary key constraints on table "argo.attribute_schema_definition" */
export enum ArgoAttributeSchemaDefinitionConstraint {
  /** unique or primary key constraint on columns "context_id", "attribute_schema_id", "name_unique" */
  AttributeSchemaDefinitionEnforceUnique = 'attribute_schema_definition_enforce_unique',
  /** unique or primary key constraint on columns "attribute_schema_definition_id" */
  AttributeSchemaDefinitionPkey = 'attribute_schema_definition_pkey'
}

/** select columns of table "argo.attribute_schema_definition" */
export enum ArgoAttributeSchemaDefinitionSelectColumn {
  /** column name */
  AttributeSchemaId = 'attribute_schema_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidationApiCheck = 'validation_api_check',
  /** column name */
  ValidationMax = 'validation_max',
  /** column name */
  ValidationMin = 'validation_min',
  /** column name */
  ValidationPattern = 'validation_pattern',
  /** column name */
  ValidationRequired = 'validation_required'
}

/** select "argo_attribute_schema_definition_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.attribute_schema_definition" */
export enum ArgoAttributeSchemaDefinitionSelectColumnArgoAttributeSchemaDefinitionAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  ValidationApiCheck = 'validation_api_check',
  /** column name */
  ValidationRequired = 'validation_required'
}

/** select "argo_attribute_schema_definition_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.attribute_schema_definition" */
export enum ArgoAttributeSchemaDefinitionSelectColumnArgoAttributeSchemaDefinitionAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  ValidationApiCheck = 'validation_api_check',
  /** column name */
  ValidationRequired = 'validation_required'
}

/** update columns of table "argo.attribute_schema_definition" */
export enum ArgoAttributeSchemaDefinitionUpdateColumn {
  /** column name */
  AttributeSchemaId = 'attribute_schema_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidationApiCheck = 'validation_api_check',
  /** column name */
  ValidationMax = 'validation_max',
  /** column name */
  ValidationMin = 'validation_min',
  /** column name */
  ValidationPattern = 'validation_pattern',
  /** column name */
  ValidationRequired = 'validation_required'
}

